import React from "react";
// No longer need to import hireRubyAndRailsPageContent directly
// import { hireRubyAndRailsPageContent } from "../data/hire-ruby-and-rails.data";

// Ensure contactSectionComponent is still imported if ContactSection uses it directly
import contactSectionComponent from "../data/contactSectionComponentData";

import Footer from "../components/footer/Footer";
import HirePageBanner from "../components/HirePageBanner/HirePageBanner";
import DevelopmentPerformance from "../components/DevelopmentPerformance/DevelopmentPerformance";
import SecondFaq from "../components/secondFaq/SecondFaq";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import HirePageExperties from "../components/hirepageExperties/HirePageExperties";
import HirePageSteps from "../components/hire-page-steps/HirePageSteps";
import HireExpertFacts from "../components/hire-expert-facts/HireExpertFacts";
import HirePageEngagmentModels from "../components/hire-page-engagment-models/HirePageEngagmentModels";
import HirePageAppIdea from "../components/hire-page-app-idea/HirePageAppIdea";
import ContactSection from "../components/contactSection/ContactSection";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import HireCombinationSection from "../components/hire-combination-sectiono/HireCombinationSection";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { useTranslation } from "react-i18next";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import SimpleModels from "../components/simpleEngagementModels";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import OurServices from "../components/our-services/OurServices";
import { hireRubyAndRailsengagementModeContent } from "../data/hire-ruby-and-rails.data";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";

const HireRubyAndRails = () => {
  // Initialize useTranslation with the namespace
  const { t } = useTranslation("hireRubyAndRailsPage");

  // Fetch all content using the t function with returnObjects: true for objects/arrays
  const helmet = t("hireRubyAndRailsPageContentData.helmet", {
    returnObjects: true,
  });
  const hirePageBanner = t("hireRubyAndRailsPageContentData.hirePageBanner", {
    returnObjects: true,
  });
  const hirePageExperties = t(
    "hireRubyAndRailsPageContentData.hirePageExperties",
    { returnObjects: true }
  );
  const developmentPerformance = t(
    "hireRubyAndRailsPageContentData.developmentPerformance",
    { returnObjects: true }
  );
  const hireCombinationSection = t(
    "hireRubyAndRailsPageContentData.hireCombinationSection",
    { returnObjects: true }
  );
  const hirePageSteps = t("hireRubyAndRailsPageContentData.hirePageSteps", {
    returnObjects: true,
  });
  const coverTheStack = t("hireRubyAndRailsPageContentData.coverTheStack", {
    returnObjects: true,
  });
  const hireExpertFacts = t("hireRubyAndRailsPageContentData.hireExpertFacts", {
    returnObjects: true,
  });
  const hirePageAppIdea = t("hireRubyAndRailsPageContentData.hirePageAppIdea", {
    returnObjects: true,
  });
  const hirePageEngagementModels = t(
    "hireRubyAndRailsPageContentData.hirePageEngagementModels",
    { returnObjects: true }
  );
  const trendsInsights = t("hireRubyAndRailsPageContentData.trendsInsights", {
    returnObjects: true,
  });
  const secondFaq = t("hireRubyAndRailsPageContentData.secondFaq", {
    returnObjects: true,
  });

  console.log(hirePageEngagementModels.discription, "nfijs");

  // Note: solutionsData is already being fetched correctly as per your original code
  // const solutionsData = t("solutionsDataContent", { returnObjects: true });
  // You would use this where 'solutions' is needed, for example:
  // solutions={solutionsData} (if you were passing it directly)

  const { t: tengagementModelContent } = useTranslation(
    "engagementModelContent"
  );

  // grab the full object once
  const engagementModelsContent = {
    heading: tengagementModelContent("heading"),
    darkHeading: tengagementModelContent("darkHeading"),
    subheading: tengagementModelContent("subheading"),
    models: tengagementModelContent("models", { returnObjects: true }),
    cta: tengagementModelContent("cta", { returnObjects: true }),
  };

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>Hire Dedicated Ruby on Rails Developers | Bitsclan</title>
        <meta name="description" content="Hire Ruby on Rails developers in USA to build custom, robust RoR web applications. Leverage our top Ruby on Rails consulting services to accelerate your business growth today!" />
        <script type="application/ld+json">
          {JSON.stringify(helmet.schema)}
        </script>
      </Helmet>

      <MegaMenu />

      {/* <HirePageBanner
        diffBannerBackgroundImage={hirePageBanner.diffBannerBackgroundImage}
        image={hirePageBanner.image}
        mainHeading={hirePageBanner.mainHeading}
        content={hirePageBanner.content}
        btnText={hirePageBanner.btnText}
        bannerList={hirePageBanner.bannerList}
      /> */}

      <ServicesPageBanner
        shortHeading={hirePageBanner?.shortHeading}
        mainHeading={hirePageBanner.mainHeading}
        description={hirePageBanner.content}
      />
      <TrustedPartner />

      <OurServices
        mainHeading={hirePageExperties?.heading}
        description={hirePageExperties?.description}
        servicesCardsData={hirePageExperties?.servicesData}
        buttonText="Schedule a Call Today"
      />

      <DevelopmentPerformance
        buttonText={developmentPerformance.btnText}
        heading={developmentPerformance.heading}
        greenHeading={developmentPerformance.greenHeading}
        subHeading={developmentPerformance.subHeading}
        solutions={developmentPerformance.solutions} // This will now correctly reference the translated solutionsData
      />

      <HireCombinationSection
        combinations={hireCombinationSection.combinations}
        heading={hireCombinationSection.heading}
        description={hireCombinationSection.description}
      />

      <HirePageSteps
        buttonText={hirePageSteps.btnText}
        heading={hirePageSteps.heading}
        subHeading={hirePageSteps.subHeading}
        steps={hirePageSteps.steps}
      />

      <CoverTheStack
        whereStart={coverTheStack.whereStart}
        mainHeading={coverTheStack.mainHeading}
        subHeading={coverTheStack.subHeading}
        tabs={coverTheStack.tabs}
        tabItems={coverTheStack.tabItems}
      />

      <HireExpertFacts
        buttonText={hireExpertFacts.btnText}
        heading={hireExpertFacts.heading}
        greenHeading={hireExpertFacts.greenHeading}
        facts={hireExpertFacts.facts}
        diffBannerBackgroundImage={hireExpertFacts.diffBannerBackgroundImage}
      />

      <HirePageAppIdea
        heading={hirePageAppIdea.heading}
        content={hirePageAppIdea.content}
      />

      {/* <HirePageEngagmentModels buttonText={hirePageEngagementModels.btnText} heading={hirePageEngagementModels?.headingContent} content={hirePageEngagementModels?.discription} hiringDetails={hirePageEngagementModels.hiringDetails} /> */}

      <SimpleModels content={hireRubyAndRailsengagementModeContent} />

      <TrendsInsights
        specificClass={trendsInsights.specificClass}
        category={trendsInsights.category}
      />

      <SecondFaq
        faqs={secondFaq.faqs}
        specificClass={secondFaq.specificClass}
        mainHeading={secondFaq.mainHeading}
        subHeading={secondFaq.subHeading}
      />

      {/* <ContactSection /> This component likely uses contactSectionComponentData directly */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default HireRubyAndRails;
